import { render, staticRenderFns } from "./customerMgt.vue?vue&type=template&id=0f4f752e&scoped=true&"
import script from "./customerMgt.vue?vue&type=script&lang=js&"
export * from "./customerMgt.vue?vue&type=script&lang=js&"
import style0 from "./customerMgt.vue?vue&type=style&index=0&id=0f4f752e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f752e",
  null
  
)

export default component.exports